import React from "react";
import { Icon, Text } from "@ilc-technology/luik";
import { LabelKey } from "../../../../Common/StoryblokTypes";
import { useDatasources } from "../../../../contexts/StoryblokContext/StoryblokContext";
import Surface from "../../../Surface/Surface";
import { PaymentStatus } from "../../../../Common/Types";

interface WhatsNextProps {
  paymentStatus: PaymentStatus | null;
}

interface StepConfig {
  titleKey: LabelKey;
  contentKey: LabelKey;
}

const STEP_CONFIG: Record<PaymentStatus | "default", StepConfig[]> = {
  [PaymentStatus.PaymentSuccess]: [
    { titleKey: LabelKey.bookingConfirmation, contentKey: LabelKey.bookingConfirmationContent },
    { titleKey: LabelKey.downloadCampusConnect, contentKey: LabelKey.downloadCampusConnectContent },
  ],
  [PaymentStatus.ReservationSuccess]: [
    { titleKey: LabelKey.completePaymentDetails, contentKey: LabelKey.completePaymentDetailsContent },
    { titleKey: LabelKey.bookingConfirmation, contentKey: LabelKey.bookingConfirmationContent },
    { titleKey: LabelKey.downloadCampusConnect, contentKey: LabelKey.downloadCampusConnectContent },
  ],
  [PaymentStatus.PaymentProcessed]: [
    { titleKey: LabelKey.bookingConfirmation, contentKey: LabelKey.bookingConfirmationContent },
    { titleKey: LabelKey.downloadCampusConnect, contentKey: LabelKey.downloadCampusConnectContent },
  ],
  default: [
    { titleKey: LabelKey.completePaymentDetails, contentKey: LabelKey.completePaymentDetailsContent },
    { titleKey: LabelKey.bookingConfirmation, contentKey: LabelKey.bookingConfirmationContent },
    { titleKey: LabelKey.downloadCampusConnect, contentKey: LabelKey.downloadCampusConnectContent },
  ],
};

const StepItem: React.FC<StepConfig> = ({ titleKey, contentKey }) => {
  const { labels } = useDatasources();
  return (
    <div>
      <div className="a-gap-x-sm flex items-center">
        <Icon className="a-bullet-icon" iconName="chevron-right" size="sm" />
        <Text variant="paragraph-body-bold">{labels[titleKey]}</Text>
      </div>
      <Text variant="paragraph-body">{labels[contentKey]}</Text>
    </div>
  );
};

const WhatsNext: React.FC<WhatsNextProps> = ({ paymentStatus }) => {
  const { labels } = useDatasources();
  const steps = STEP_CONFIG[paymentStatus || "default"] || STEP_CONFIG.default;

  return (
    <div className="a-gap-y flex flex-col">
      <Surface>
        <div className="flex-start a-gap-y-sm flex flex-col justify-center self-stretch" data-testid="whatIsNext-blok">
          <Text variant="heading-5-bold">{labels[LabelKey.whatsNext]}</Text>
          {steps.map((step, index) => (
            <StepItem key={index} {...step} />
          ))}
        </div>
      </Surface>
    </div>
  );
};

export default WhatsNext;
